import React from 'react';
import "../../styles/home/view_item.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCast, getItem, getSimilarItems } from "../repositories/movies_and_tvseries";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import ViewCastDetails from "./view_cast_details";
import ViewProductionDetails from "./view_production_details";
import AddItemToCollection from "../collections/add_item_to_collection";
import CastVote from "../vote/cast_vote";
import ReactTooltip from 'react-tooltip';

import backArrowIcon from "../../images/back_arrow_icon_2.png";
import imageCollage from "../../images/image_collage.png";
import noImage from "../../images/collections/no_image.png";
import activeSaveImage from "../../images/home/save_icon/active_save.png";
import inactiveSaveImage from "../../images/home/save_icon/inactive_save.png";
import activeLikeImage from "../../images/home/like_icon/active_like.png";
import inactiveLikeImage from "../../images/home/like_icon/inactive_like.png";
import activeVoteIcon from "../../images/vote/vote_done.png";
import inactiveVoteIcon from "../../images/vote/inactive_vote_b.png";

const ViewItem = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [getIsVoteShow, setIsVoteShow] = useState(false);
    const [getIsCollectionsShow, setIsCollectionsShow] = useState(false);
    const [getOnShowCastDetails, setOnShowCastDetails] = useState(false);
    const [getOnShowProductionDetails, setOnShowProductionDetails] = useState(false);
    const [getOnSave, setOnSave] = useState(false);
    const [getUserLike, setUserLike] = useState(false);
    const [getOnVote, setOnVote] = useState(false);
    const [getIsDiscussion, setIsDiscussion] = useState(false);
    const [getSeasonsDetails, setSeasonsDetails] = useState([]);
    const [getProductionDetails, setProductionDetails] = useState([]);
    const [getSimilarDetails, setSimilarDetails] = useState([]);
    const [getCastDetails, setCastDetails] = useState([]);
    const [getUserId, setUserId] = useState("");
    const [getCastId, setCastId] = useState("");
    const [getProductionId, setProductiontId] = useState("");
    const [getItemName, setItemName] = useState("");
    const [getItemPoster, setItemPoster] = useState("");
    const [getItemOverview, setItemOverview] = useState("");
    const [getItemReleaseDate, setItemReleaseDate] = useState("");
    const [getItemFirstAirDate, setItemFirstAirDate] = useState("");
    const [getItemLastAirDate, setItemLastAirDate] = useState("");
    const [getItemRuntime, setItemRuntime] = useState("");
    const [getItemEpisodesRuntime, setItemEpisodesRuntime] = useState("");
    const [getItemGenre, setItemGenre] = useState("");
    const [getItemStatus, setItemStatus] = useState("");
    const [getItemLanguage, setItemLanguage] = useState("");
    const [getWatchLink, setWatchLink] = useState("");
    const [getCardSpaceNum, setCardSpaceNum] = useState(1);
    const [getCardSpaceNumSimilar, setCardSpaceNumSimilar] = useState(1);

    const path = location.pathname.split("/");
    const type = path[path.indexOf("home") + 2];
    const genre = path[path.indexOf("home") + 1];
    const itemId = path.pop();

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.toLocaleDateString('en-US', {
        month: 'long',
    });
    const date = `${currentMonth.toLowerCase()}_${currentYear}`;

    const onSetCastId = (id) => {
        setOnShowCastDetails(true);
        setOnShowProductionDetails(false);
        setCastId(id);
    };

    const onSetProductionId = (id) => {
        setOnShowCastDetails(false);
        setOnShowProductionDetails(true);
        setProductiontId(id);
    };

    const goBack = () => {
        navigate(-1);
    };

    const onSave = () => {
        setIsCollectionsShow(true);
    }

    const onVote = () => {
        setIsVoteShow(true);
    }

    const watchNow = (url) => {
        if (url !== "" || url !== null) {
            window.open(url, '_blank');
        }
    }

    const onLike = async () => {
        try {
            const idLike = `${type}_${itemId}`
            const userRef = doc(firebaseFirestore, 'User Details', getUserId); 
            const userDoc = await getDoc(userRef);
            if (userDoc.exists()) {
                let likesList = userDoc.data()["likes"] || [];
                if (likesList.includes(idLike)) {
                    likesList = likesList.filter(id => id !== idLike);
                } else {
                    likesList.push(idLike);
                }

                await updateDoc(userRef, { [`likes`]: likesList }, { merge: true });
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    const retrieveItemDetails = async () => {
        let newItemList = [];
        let seasonsList = [];
        let productionList = [];
        const details = await getItem({itemId, type: type === "movie" ? type : "tv"});
        document.getElementById("home_view_item_backdrop").style.backgroundImage = `url(https://image.tmdb.org/t/p/w500${details["backdrop_path"] === "" || details["backdrop_path"] === null ? imageCollage : details["backdrop_path"]})`;
        setItemPoster(details["poster_path"] === "" || details["poster_path"] === null ? noImage : details["poster_path"]);
        setItemOverview(details["overview"] === "" || details["overview"] === null ? `Unable to retrieve the description of this ${type}` : details["overview"]);
        setItemStatus(details["status"] === "" || details["status"] === null ? "Unknown" : details["status"]);
        setWatchLink(details["homepage"]);
        setItemLanguage(details["original_language"]);
        if (type === "movie") {
            setItemName(details["original_title"] === "" || details["original_title"] === null ? `Unable to retrieve the title of this ${type}` : details["original_title"]);
            setItemReleaseDate(details["release_date"] === "" || details["release_date"] === null ? "Unknown" : details["release_date"]);
            setItemRuntime(details["runtime"] === "" || details["runtime"] === null ? "Unknown" : `${details["runtime"]}`);
            setSeasonsDetails(null);
        } else {
            setItemName(details["original_name"] === "" || details["original_name"] === null ? `Unable to retrieve the title of this ${type}` : details["original_name"]);
            setItemFirstAirDate(details["first_air_date"] === "" || details["first_air_date"] === null ? "Unknown" : details["first_air_date"]);
            setItemLastAirDate(details["last_air_date"] === "" || details["last_air_date"] === null ? "Unknown" : details["last_air_date"]);
            setItemEpisodesRuntime(`${details["episode_run_time"].join(", ")}`);

            details["seasons"].forEach((season) => {
                const isDuplicate = seasonsList.some(item => item.id === season.id);
                if (!isDuplicate) {
                    seasonsList.push({
                        id: season.id,
                        air_date: season.air_date,
                        episode_count: season.episode_count,
                        name: season.name,
                        poster_path: season.poster_path,
                    });
                }
            });
            setSeasonsDetails(seasonsList);
        }

        details["production_companies"].forEach((companies) => {
            const isDuplicate = productionList.some(item => item.id === companies.id);
            if (!isDuplicate) {
                if (companies.id != null || companies.id !== "") {
                    productionList.push({
                        id: `${companies.id}`,
                        logo_path: `${companies.logo_path == null ? "" : companies.logo_path}`,
                        name: `${companies.name == null ? "" : companies.name}`,
                        origin_country: `${companies.origin_country == null ? "" : companies.origin_country}`,
                    });
                }
            }
        });
        setProductionDetails(productionList);

        details["genres"].forEach((result) => {
            const isDuplicate = newItemList.some(item => item.name === result.name);
            if (!isDuplicate) {
                newItemList.push({
                    name: result.name,
                });
            }
        });
        const genreNames = newItemList.map(item => item.name);
        setItemGenre(genreNames.join(", ") !== "" ? genreNames.join(", ") : "Unknown");
    }

    const retrieveCastDetails = async () => {
        let newCastList = [];
        const castDetails = await getCast({itemId, type: type === "movie" ? type : "tv"});
        castDetails["cast"].forEach((cast) => {
            if (cast.known_for_department === "Acting") {
                const isDuplicate = newCastList.some(item => item.id === cast.id);
                if (!isDuplicate) {
                    newCastList.push({
                        id: cast.id,
                        name: cast.original_name,
                        character: cast.character,
                        image: cast.profile_path
                    });
                }
            }
        });
        setCastDetails(newCastList);
    }

    const retrieveSimilarItemsFunc = async () => {
        let newSimilarList = [];
        let genreId = 28;

        if (genre === "thriller") {
            genreId = 53;
        } else if (genre === "mystery") {
            genreId = 9648;
        } else if (genre === "family") {
            genreId = 10751;
        } else if (genre === "horror") {
            genreId = 27;
        } else if (genre === "comedy") {
            genreId = 35;
        } else if (genre === "animation") {
            genreId = 16;
        } else if (genre === "drama") {
            genreId = 18;
        } else if (genre === "adventure") {
            genreId = 10759;
        } else if (genre === "romance") {
            genreId = 10749;
        } else if (genre === "science_fiction") {
            genreId = 878;
        } else if (genre === "news") {
            genreId = 10763;
        } else {
            genreId = 28;
        }

        const similarDetails = await getSimilarItems({itemId: itemId, genreId: genreId, language: getItemLanguage, type: type === "movie" ? type : "tv"});
        similarDetails["results"].forEach((movie) => {
            const isDuplicate = newSimilarList.some(item => item.id === movie.id);
            if (!isDuplicate) {
                newSimilarList.push({
                    id: movie.id,
                    title: `${type === "movie" ? movie.title : movie.name}`,
                    poster_path: movie.poster_path,
                    type: type,
                });
            }
        });
        setSimilarDetails(newSimilarList);
    }

    const getCardSpace = () => {
        const parent = document.getElementById('home_view_item_cast_row_a');
        const parentWidth = parent.offsetWidth;
        const childWidth = window.innerWidth <= 600 ? 120 : 150 + 30;
        const childWidthSimilar = window.innerWidth <= 600 ? 100 + 0 : 150 + 30;
        const childWidthProduction = window.innerWidth <= 600 ? 250 : 300;
        const numChildren = Math.floor(parentWidth / childWidth);
        const numChildrenSimilar = Math.floor(parentWidth / childWidthSimilar);
        const numChildrenProduction = Math.floor(parentWidth / childWidthProduction);
        setCardSpaceNum(numChildren);
        setCardSpaceNumSimilar(numChildrenSimilar);
        parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;

        if (getSeasonsDetails !== null) {
            if (getSeasonsDetails.length > 0) {
                const seasonParent = document.getElementById('home_view_item_seasons_grid');
                seasonParent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
            }
        }

        if (getSimilarDetails.length > 0) {
            const similarParent = document.getElementById('similar_action_container_home_screen');
            similarParent.style.gridTemplateColumns = `repeat(${numChildrenSimilar}, 1fr)`;
        }

        if (getProductionDetails !== null) {
            const productionParent = document.getElementById("home_view_item_production_grid");
            productionParent.style.gridTemplateColumns = `repeat(${numChildrenProduction}, 1fr)`;
        }
    };

    useEffect(() => {
        try {
            const userRef = doc(firebaseFirestore, 'User Details', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                let num = 0;
                if (docSnapshot.exists()) {
                    const userData = docSnapshot.data();
                    Object.keys(userData).forEach((fieldName) => {
                        if (fieldName === "likes") {
                            const likesList = userData[fieldName];
                            if (likesList.includes(`${type}_${itemId}`)) {
                                setUserLike(true);
                            }else{
                                setUserLike(false);
                            }
                        }
                    });
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    }, [getUserId, itemId]);

    useEffect(() => {
        try {
            const itemRef = doc(firebaseFirestore, 'User Votes', date);
            const scription = onSnapshot(itemRef, async (docSnapshot) => {
                let num = 0;
                if (docSnapshot.exists()) {
                    const itemData = docSnapshot.data();
                    Object.keys(itemData).forEach((fieldName) => {
                        if (fieldName === getUserId) {
                            const data = itemData[fieldName];
                            Object.keys(data).forEach((item) => {
                                if (data[item] === `${type}_${itemId}`) {
                                    num += 1;
                                }
                            })
                        }
                    });

                    if (num > 0) {
                        setOnVote(true);
                    } else {
                        setOnVote(false);
                    }
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    }, [getUserId]);

    useEffect(() => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                let num = 0;
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName.startsWith("collection")) {
                            const collection = collectionsData[fieldName];
                            if (collection["items"].includes(`${type}_${itemId}`)) {
                                num += 1;
                            }
                        }
                    });
                }

                if (num <= 0) {
                    setOnSave(false);
                }else{
                    setOnSave(true);
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    }, [getUserId, itemId]);

    useEffect(() => {
        const parent = document.getElementById('home_view_item_cast_row_a');

        if (getCastDetails.length < 1) {
            parent.style.display = "flex";
            parent.style.flexDirection = "column";
            parent.style.alignItems = "center";
        } else if (getCastDetails.length > 0) {
            parent.style.display = "grid";
            parent.style.width = "100%";
        }
    }, [getCastDetails]);
    
    useEffect(() => {
        const discussionKey = `${type}${itemId}${getItemName[0]}`;
        if (discussionKey !== "") {
            try {
                const discussionRef = doc(firebaseFirestore, 'User Discussion', discussionKey);
                const unsubscribe = onSnapshot(discussionRef, (docSnapshot) => {
                    if (docSnapshot.exists()) {
                        const chatData = docSnapshot.data();
                        if (!chatData || Object.keys(chatData).length === 0) {
                            setIsDiscussion(false);
                        } else {
                            setIsDiscussion(true);
                        }
                    };
                });

                return () => unsubscribe
            } catch (error) {
                console.log(`Error ${error}`);
            }
        };
    }, [getItemName]);

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []);

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getSimilarDetails]);

    useEffect(() => {
        retrieveItemDetails();
        retrieveCastDetails();
        retrieveSimilarItemsFunc();
        const div = document.getElementById('home_view_item_box');
        div.scrollTop = 0;
    }, [itemId]);

    return(
        <div className="home_view_item_screen">
            <div className="home_view_item_head_container_row">
                <div className="home_item_section_head_container_row">
                    <img alt='back' onClick={goBack} className="home_item_section_back" src={backArrowIcon} /> 
                    <p className="home_view_item_header">{type.charAt(0).toUpperCase() + type.slice(1)}</p>
                </div>
                <p onClick={() => watchNow(getWatchLink)} className="home_view_item_back">Homepage</p>
            </div>
            <div className="home_view_item_backdrop_container">
                <div id="home_view_item_backdrop" className="home_view_item_backdrop"></div>
                <div className="home_view_item_backdrop_overlay"></div>
                <div className="home_view_item_backdrop_content">
                    <img alt='poster' loading='lazy' src={`https://image.tmdb.org/t/p/w500${getItemPoster}`} className="home_view_item_poster" />
                    <div className="home_view_item_backdrop_content_column">
                        <div className="home_view_item_backdrop_content_column_a">
                            <p className="home_view_item_backdrop_content_column_header">{getItemName}</p>
                            <p className="home_view_item_backdrop_content_column_overview">{getItemOverview}</p>
                        </div>
                        <div className="home_view_item_backdrop_content_column_image_row">
                            <img alt='like' onClick={onLike} src={getUserLike ? activeLikeImage : inactiveLikeImage} className="likeItemImage" />
                            <div className="saveItemImage_con">
                                <img alt='save' onClick={onSave} src={getOnSave ? activeSaveImage : inactiveSaveImage} className="saveItemImage" />
                                <AddItemToCollection getShow={getIsCollectionsShow} setShow={setIsCollectionsShow} getItemId={`${type}_${itemId}`} />
                            </div>
                            <div className="saveItemImage_con">
                                <img alt='vote' onClick={onVote} data-tip data-for="vote_item_icon" src={getOnVote ? activeVoteIcon : inactiveVoteIcon} className="saveItemImage" />
                                <ReactTooltip effect='solid' id="vote_item_icon" place="top">{`Vote for ${getItemName}`}</ReactTooltip>
                                <CastVote getShow={getIsVoteShow} setShow={setIsVoteShow} getItemId={itemId} getItemName={getItemName} getItemType={type} getItemGenre={getItemGenre} getSingleGenre={genre} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="home_view_item_box" className="home_view_item_box">
                <div className="home_view_item_some_details">
                    {
                        type === "movie"
                        ? <p>Release date: {getItemReleaseDate}</p>
                        : null
                    }
                    {
                        type === "series"
                        ? <p>First air date: {getItemFirstAirDate}</p>
                        : null
                    }
                    {
                        type === "series"
                        ? <p>Last air date: {getItemLastAirDate}</p>
                        : null
                    }
                    {
                        type === "movie"
                        ?   getItemRuntime === null || getItemRuntime === ""
                            ? null
                            : <p>Runtime: {getItemRuntime} {getItemRuntime === "Unknown" ? "" : "minutes"}</p>
                        :   getItemEpisodesRuntime === null || getItemEpisodesRuntime === ""
                            ? null
                            : <p> Episode runtime: {getItemEpisodesRuntime} minutes</p>
                    }
                    {
                        getItemGenre === null || getItemGenre === ""
                        ? null
                        : <p>Genre(s): {getItemGenre}</p>
                    }
                    {
                        getItemStatus === null || getItemStatus === ""
                        ? null
                        : <p>Status: {getItemStatus}</p>
                    }
                </div>

                <p className="home_view_item_cast_discussions">Discussions</p>
                <div className="home_view_item_cast_discussions_container">
                    <Link to={`/main_back/home/${type}/discussions/${getItemName.toLowerCase()}/${itemId}`} className="action_container_sub_home_screen_b"><div className="home_view_item_cast_discussions_tab"> 
                        {
                            getIsDiscussion
                            ? <div className="home_view_item_cast_discussions_tab_empty"> Click to see what people are saying about {getItemName} <span role='img' aria-label="eyes">👀</span></div>
                            : <p className="home_view_item_cast_discussions_tab_empty">There are no discussions on {getItemName}. Click to start a discussion <span role='img' aria-label="smiling face">😊</span></p>
                        }
                    </div></Link>
                </div>

                <div className="home_view_item_cast_head_row">
                    <p className="home_view_item_cast_header">Cast and Crew</p>
                    <Link className="action_container_sub_home_screen_b" to={`/main_back/home/${type}/cast/${getItemName.toLowerCase()}/${itemId}`}><p className="home_view_item_cast_see_more">see more ↠</p></Link>
                </div>
                <div className="home_view_item_cast_row">
                    <div id="home_view_item_cast_row_a" className="home_view_item_cast_row_a">
                        {
                            getCastDetails.length > 0
                            ? getCastDetails.map((cast, index) => (
                                index < getCardSpaceNum
                                ? <div key={index} onClick={() => onSetCastId(cast.id)} className="home_view_item_cast_card">
                                    <img alt='cast' loading='lazy' src={cast.image === "" || cast.image === null ? noImage : `https://image.tmdb.org/t/p/w500${cast.image}`} className="home_view_item_cast_card_image" />
                                    <div className="home_view_item_cast_card_title">
                                        <p className="home_view_item_cast_card_character">{cast.character}</p>
                                        <p className="home_view_item_cast_card_name">{cast.name}</p>
                                    </div>
                                </div>
                                : null
                            ))
                            : <p className="home_view_item_cast_row_error">Unable to get the cast of {getItemName} at the moment.</p>
                        }
                    </div>
                </div>

                { 
                    getSeasonsDetails == null
                    ? null
                    : <p className="home_view_item_cast_discussions">Seasons</p>
                }

                {
                    getSeasonsDetails != null
                    ? <div id='home_view_item_seasons_grid' className="home_view_item_seasons_grid">
                        {
                            getSeasonsDetails.length > 0
                            ? getSeasonsDetails.map((season, index) => (
                                <div key={index} className="home_view_item_seasons_card">
                                    <img alt='Season' loading='lazy' src={season.poster_path === "" || season.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${season.poster_path}`} className="home_view_item_seasons_image" />
                                    <div className="home_view_item_seasons_column">
                                        <p className="home_view_item_seasons_name">{season.name}</p>
                                        <p className="home_view_item_seasons_sub">{season.episode_count} episodes</p>
                                        <p className="home_view_item_seasons_sub">{season.air_date}</p>
                                    </div>
                                </div>
                            ))
                            : <p className="home_view_item_cast_row_error">Unable to get the seasons of {getItemName} at the moment.</p>
                        }
                    </div>
                    : null
                }

                { 
                    getProductionDetails == null 
                    ? null
                    : <p className="home_view_item_cast_discussions">Production Companies</p> 
                }

                {
                    getProductionDetails != null
                    ? <div id="home_view_item_production_grid" className="home_view_item_production_grid">
                        {
                            getProductionDetails.length > 0
                            ? getProductionDetails.map((production, index) => (
                                <div key={index} onClick={() => onSetProductionId(`${production.id === "" || production.id == null ? "" : production.id}`)} className="home_view_item_production_block">
                                    <img alt='season' loading='lazy' src={production.logo_path === "" || production.logo_path === null ? noImage : `https://image.tmdb.org/t/p/w500${production.logo_path}`} className="home_view_item_production_image" />
                                    <div className="home_view_item_production_column">
                                        <p className="home_view_item_production_name">{production.name}</p>
                                        <p className="home_view_item_production_country">{production.origin_country}</p>
                                    </div>
                                </div>
                            ))
                            : <p className="home_view_item_cast_row_error">Unable to get the companies that produced {getItemName} at the moment.</p>
                        }
                    </div>
                    : null 
                }

                { 
                    getSimilarDetails.length <= 0 || getSimilarDetails == null 
                    ? null
                    : <p className="home_view_item_cast_discussions">You might also like</p> 
                }

                {
                    getSimilarDetails.length <= 0 || getSimilarDetails == null
                    ? null
                    : <div id="similar_action_container_home_screen" className="similar_action_container_home_screen">
                        <div id="similar_card_home_screen" className="similar_card_home_screen"></div>
                        {
                            getSimilarDetails.map((movie, index) => (
                                index < getCardSpaceNumSimilar
                                ? <Link key={index} className="similar_action_container_sub_home_screen_a" to={`/main_back/home/${genre}/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                    <img
                                        loading='lazy'
                                        src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                        alt={movie.title}
                                        className="similar_movie_poster"
                                    />
                                    <p className="similar_movie_item_p">{movie.title}</p>
                                </div></Link>
                                : null
                            ))
                        }
                    </div>                    
                }                
            </div>
            {
                getCastId === "" || getCastId == null
                ? null
                : <ViewCastDetails getShow={getOnShowCastDetails} setShow={setOnShowCastDetails} getCastId={getCastId} />
            }

            {
                getProductionId === "" || getProductionId == null
                ? null
                : <ViewProductionDetails getShow={getOnShowProductionDetails} setShow={setOnShowProductionDetails} getProductionId={getProductionId} />
            }
        </div>
    );
}

export default ViewItem;